import { render, staticRenderFns } from "./StatusCheckboxGroup.vue?vue&type=template&id=31dc99b2&scoped=true&"
import script from "./StatusCheckboxGroup.vue?vue&type=script&lang=js&"
export * from "./StatusCheckboxGroup.vue?vue&type=script&lang=js&"
import style0 from "./StatusCheckboxGroup.vue?vue&type=style&index=0&id=31dc99b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31dc99b2",
  null
  
)

export default component.exports